import { getEwalletAccount } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  status: {
    initialize: false,
    loading: false,
    success: false,
    error: false,
  },
};

const mutations = {
  setStatus(state, row) {
    state.status = row;
  },
};
const getters = {};
const actions = {
  getEwalletAccount({ rootState, commit }, key) {
    commit('setStatus', { loading: true });
    return new Promise((resolve, reject) => {
      return getEwalletAccount(key)
        .then(r => {
          if (r.data.IsSuccess) {
            commit('setStatus', { success: r.data.Data });
            resolve(r.data.Data);
          } else {
            commit('setStatus', { error: 'Payout.EwalletAccount.Error' });
            reject();
          }
        })
        .catch(() => {
          commit('setStatus', { error: 'Payout.EwalletAccount.Error' });
          reject();
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
